import { prismicRichTextContentSerializer } from '@monofront/business/utils/prismicRichTextContentSerializer';
import { PrismicContentSerializer } from '@monofront/types';
import { useFeatureValue } from '@monofront/business/contexts';
import { FREE_SHIPPING_THRESHOLD } from '@monofront/business/constants';

export const useFreeDeliverySerializer = (): PrismicContentSerializer => {
  const freeDeliveryLimit = useFeatureValue(...FREE_SHIPPING_THRESHOLD);

  return prismicRichTextContentSerializer({
    FREEDELIVERYLIMIT: freeDeliveryLimit.toString(),
  });
};
